<template>
  <VAlert
    v-if="!isHidden"
    class="dialog-alert"
    :class="getClass"
    :icon="getIcon"
  >
    <v-layout align-start column>
      <template>
        <span v-if="headerText" class="alert-header">
          {{ $t(headerText) }}
        </span>
        <span class="alert-body">
          <div v-html="$t(bodyText)"></div>
          <a v-if="link"
             class="link"
             target="blank"
             :href="link"
          >
            {{ $t(linkText) }}
          </a>
        </span>
        <v-btn v-if="buttonFunction"
               class="alert-cta-button"
               text
               elevation="0"
               @click="buttonFunction"
        >
          {{ $t(buttonText) }}
        </v-btn>
        <button v-if="closeButton" @click="closeAlert()" class="icon-close_new"></button>
      </template>
    </v-layout>
  </VAlert>
</template>

<script>

export default {
  name: "VcitaAlert",
  data() {
    return {
      isHidden: false
    }
  },
  props: {
    type: {
      type: String,
      required: true
    },
    headerText: {
      type: String,
      required: false
    },
    bodyText: {
      type: String,
      required: false
    },
    buttonFunction: {
      type: Function,
      required: false
    },
    buttonText: {
      type: String,
      required: false
    },
    link: {
      type: String,
      required: false
    },
    linkText: {
      type: String,
      required: false
    },
    isStripe: {
      type: Boolean,
      required: false
    },
    closeButton: {
      type: Boolean,
      required: false
    }
  },

  methods: {
    getType() {
      return this.type.toLowerCase();
    },
    getStripe() {
      return this.isStripe ? 'stripe' : '';
    },
    closeAlert() {
      this.isHidden = true;
    }
  },
  computed: {
    getClass() {
      return 'vcita-alert-' + this.getType() + ' ' + this.getStripe();
    },
    getIcon() {
      switch (this.getType()) {
        case 'warning':
          return 'icon-Warning';
        case 'info':
          return 'icon-Info';
        case 'success':
          return 'icon-v-circle-outline-22';
        default:
          return 'icon-' + this.getType();
      }
    }
  }
};
</script>


<style lang="scss">

@import "@/assets/scss/abstract/_variables.scss";
@import "@/assets/scss/abstract/_mixins.scss";

.dialog-alert {
  padding: 12px;
  padding-inline-end: 36px;
  font-family: var(--primary-font-family);

  .icon-close_new {
    position: absolute;
    @include i-position-mirror(right, 0);
    margin: 0 12px;

  }

  &.stripe.v-alert {
    border-radius: 0;
    border-top: none;
    border-left: none;
    border-right: none;
    padding: 12px 24px;
    @include md-and-up {
      padding: 12px 16px;
    }
  }

  &.vcita-alert-attention {
    border: 1px solid #FBCBC9;
    background-color: #FDE8E7;

    i {
      color: #F2514A;
    }
  }

  &.vcita-alert-warning {
    border: 1px solid #FFEDB8;
    background-color: #FFF7E0;

    .v-alert__wrapper i {
      color: #FFC511;
    }
  }

  &.vcita-alert-info {
    border: 1px solid #C8DDFF;
    background-color: #E7F0FF;

    .v-alert__wrapper i {
      color: #478FFF;
    }
  }

  &.vcita-alert-success {
    border: 1px solid #CFF8E1;
    background-color: #EAFCF2;

    i {
      color: #54D28C;
    }
  }

  .v-alert__wrapper i {
    font-size: 20px;
    height: 20px;
    width: 20px;
    min-width: 20px;
  }

  .alert-header {
    font-weight: 600;
    font-size: 15px;
    line-height: 20px;
    color: rgba(0, 0, 0, 0.87);
  }

  .alert-body {
    font-size: 13px;
    line-height: 20px;
    color: rgba(0, 0, 0, 0.87);
  }

  .alert-cta-button {
    text-transform: none;
    border: 1px solid #EAEDF2;
    background-color: #fff;
    height: 32px;
    padding: 8px 12px;
    margin-top: 8px;
    box-sizing: border-box;
    border-radius: 4px;

    span {
      font-weight: 500;
      font-size: 13px;
      letter-spacing: normal;
      line-height: 16px;
    }
  }
}
</style>
